"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from "next/navigation";
import { ProfileActivityLogProxyActionStateChanged } from "@/entities/IProfile";
import { PROFILE_PROXY_ACTION_LABELS } from "@/entities/IProxy";
import { AcceptActionRequestActionEnum } from "@/generated/models/AcceptActionRequest";
import ProfileActivityLogItemAction from "./utils/ProfileActivityLogItemAction";
import { UserPageTabType } from "@/components/user/layout/UserPageTabs";
import CommonProfileLink from "@/components/user/utils/CommonProfileLink";
const ACTION: Record<AcceptActionRequestActionEnum, string> = {
  [AcceptActionRequestActionEnum.Accept]: "accepted",
  [AcceptActionRequestActionEnum.Reject]: "rejected",
  [AcceptActionRequestActionEnum.Revoke]: "revoked",
  [AcceptActionRequestActionEnum.Restore]: "restored"
};
export default function ProfileActivityLogProxyActionState(t0) {
  const $ = _c(18);
  const {
    log
  } = t0;
  const searchParams = useSearchParams();
  const handleOrWallet = log.target_profile_handle ?? "";
  let t1;
  if ($[0] !== searchParams) {
    t1 = (searchParams?.get("user") as string)?.toLowerCase();
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== handleOrWallet) {
    t2 = handleOrWallet.toLowerCase();
    $[2] = handleOrWallet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isCurrentUser = t1 === t2;
  const tabTarget = UserPageTabType.PROXY;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ProfileActivityLogItemAction action="changed" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleOrWallet || $[6] !== isCurrentUser) {
    t4 = <CommonProfileLink handleOrWallet={handleOrWallet} isCurrentUser={isCurrentUser} tabTarget={tabTarget} />;
    $[5] = handleOrWallet;
    $[6] = isCurrentUser;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ProfileActivityLogItemAction action="proxy" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = PROFILE_PROXY_ACTION_LABELS[log.contents.type];
  let t7;
  if ($[9] !== t6) {
    t7 = <span className="tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-200">{t6}</span>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ProfileActivityLogItemAction action="status to" />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = ACTION[log.contents.state_change_type];
  let t10;
  if ($[12] !== t9) {
    t10 = <span className="tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-200">{t9}</span>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t4 || $[16] !== t7) {
    t11 = <>{t3}{t4}{t5}{t7}{t8}{t10}</>;
    $[14] = t10;
    $[15] = t4;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}